<div>
  <div class="payment payment-method" [formGroup]="payment">
    <p i18n  class="title">PAYMENT METHOD</p>
    <div class="p-body">
      <p i18n  class="desc">Select a Payment Method</p>
      <div class="payment">
        <div class="form-check">
          <input class="form-check-input" type="radio" name="payment_method" value="2" checked formControlName="payment_method">
          <label i18n class="form-check-label" for="paypal">
            Paypal
          </label>
          <img src="./assets/image/dashboard/pypal.jpg" alt="paypal" class="paypal">
        </div>
        <div [ngStyle]="payment.value.payment_method=='2'?{} : { 'display': 'none'}" class="payment-container">
          <div #paypal id="paypal"></div>
        </div>
      </div>
      <div class="payment" *ngIf="klarnaAvailable">
        <div class="form-check">
          <input class="form-check-input" type="radio" name="payment_method" id="klarna" value="1" formControlName="payment_method">
          <label i18n class="form-check-label" for="klarna">
            Klarna
          </label>
          <img src="./assets/image/dashboard/klarna.svg" alt="klarna" class="klarna">
        </div>
      </div>
      <div [ngStyle]="payment.value.payment_method=='1'?{} : { 'display': 'none'}" class="klarna-container">
        <div style="margin: auto;padding-bottom: 30px;">
          <img src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.svg" style="width: 220px; margin: auto;"> 
        </div>
        <div id="klarna-payments-container" style="width: 500px; margin: auto;">
        </div>
        <!--Button to trigger authorize call-->
        <button i18n class="authorize" (click)="klarnaAutorize()">Buy</button>
      </div>
      <!-- {{klarnaObj | json}} -->
      
    </div>
  </div>
</div>